import React from 'react';
import { SpacingBox, SyncIcon, FlexBox } from '../../Components';
import { hasOrderFailedToSync, handleSubmitOrder } from '../../utils/order';

export const OrderStatusAndResync = (props) => {
  const onSuccess = () => {
    return;
  };
  const onFailure = () => {
    return;
  };

  return (
    <FlexBox alignItems='center'>
      <SpacingBox marginRight='sm'>
        {hasOrderFailedToSync({
          status: props.order.status,
        }) && (
          <SyncIcon
            onClick={() =>
              handleSubmitOrder(
                props.order,
                props.context,
                props.history,
                onSuccess,
                onFailure
              )
            }
          />
        )}
      </SpacingBox>
    </FlexBox>
  );
};
